import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const InstructorDashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [selectedCourse, setSelectedCourse] = useState('grit1');

  const dashboardOptions = [
    {
      icon: 'fas fa-video',
      title: 'Manage Course Videos',
      description: 'Add, release, and manage all your course videos',
      action: () => navigate('/manage-videos'),
      color: '#1a1a1a'
    },
    {
      icon: 'fas fa-calendar-alt',
      title: 'Manage Weekly Labs',
      description: 'Add, release, and manage your lab content',
      action: () => navigate('/manage-labs'),
      color: '#1a1a1a'
    },
    {
      icon: 'fas fa-graduation-cap',
      title: 'Manage Tutorials',
      description: 'Add, release, and manage your tutorial content',
      action: () => navigate('/manage-tutorials'),
      color: '#1a1a1a'
    },
    {
      icon: 'fas fa-clipboard-list',
      title: 'Manage Attendance',
      description: 'Open, close, and manage weekly attendance forms',
      action: () => navigate('/manage-attendance'),
      color: '#1a1a1a'
    }
  ];

  return (
    <div style={{ background: '#ffffff', minHeight: 'calc(100vh - 70px)', padding: '4rem 2rem' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header with Course Selector */}
        <div style={{ marginBottom: '5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '2rem' }}>
          <div style={{ borderLeft: '4px solid #1a1a1a', paddingLeft: '1.5rem', flex: 1 }}>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-1px', margin: '0 0 0.5rem 0' }}>
              Instructor Dashboard
            </h1>
            <p style={{ fontSize: '1.1rem', color: '#666', margin: 0 }}>
              Welcome back, {user?.email || 'Instructor'}! Manage your course content from here.
            </p>
          </div>
          
          {/* Course Selector Dropdown - Right Aligned */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: '200px' }}>
            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#1a1a1a' }}>Select Course:</label>
            <select
              value={selectedCourse}
              onChange={(e) => setSelectedCourse(e.target.value)}
              style={{
                padding: '0.5rem 0.75rem',
                borderRadius: '6px',
                border: '2px solid #1a1a1a',
                fontSize: '0.9rem',
                fontWeight: 600,
                cursor: 'pointer',
                background: '#ffffff',
                color: '#1a1a1a',
                appearance: 'none',
                backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 0.5rem center',
                backgroundSize: '1.2em 1.2em',
                paddingRight: '2rem'
              }}
            >
              <option value="grit1">GRIT 1</option>
              <option value="ai" disabled>AI & Practical Applications (Coming Soon)</option>
            </select>
          </div>
        </div>

        {/* Management Options */}
        <div style={{ marginTop: '5rem', marginBottom: '5rem' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '3rem', color: '#1a1a1a', paddingBottom: '1rem', borderBottom: '2px solid #e8e8e8' }}>
            Quick Access
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
            {dashboardOptions.map((option, index) => (
              <div
                key={index}
                onClick={option.action}
                style={{
                  background: '#f9f9f9',
                  border: '2px solid #e8e8e8',
                  borderRadius: '6px',
                  padding: '1.5rem',
                  cursor: 'pointer',
                  transition: 'all 300ms ease',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '1rem',
                  textAlign: 'center'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.1)';
                  e.currentTarget.style.borderColor = '#1a1a1a';
                  e.currentTarget.style.backgroundColor = '#ffffff';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.borderColor = '#e8e8e8';
                  e.currentTarget.style.backgroundColor = '#f9f9f9';
                }}
              >
                <div style={{ flexShrink: 0 }}>
                  <i className={option.icon} style={{
                    fontSize: '1.75rem',
                    color: '#7A5107'
                  }}></i>
                </div>
                <div>
                  <h3 style={{
                    fontSize: '1.05rem',
                    fontWeight: 700,
                    margin: '0',
                    color: '#1a1a1a'
                  }}>
                    {option.title}
                  </h3>
                  <p style={{
                    fontSize: '0.85rem',
                    color: '#666',
                    margin: '0.25rem 0 0 0'
                  }}>
                    {option.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default InstructorDashboard;
